module.exports = __webpack_public_path__ + "img/subscriptions.74d97909.svg";